module.exports = __webpack_public_path__ + "static/media/CircularStd-Medium.9475d6a0.ttf";